module.exports = __webpack_public_path__ + "static/media/15100.ea3c723b.png";